import { render, staticRenderFns } from "./DoneView.vue?vue&type=template&id=b975f6fa&"
import script from "./DoneView.vue?vue&type=script&lang=js&"
export * from "./DoneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports